<template>
  <!--
      作者 luoyiming
      时间：2020-06-09
      描述：会员-积分管理-积分设置
  -->
  <div class="pb50">
    <el-form ref="form" size="small" :model="form" label-width="200px">
      <div class="common-form">充值设置</div>
      <el-form-item label="是否开启余额充值">
        <el-radio-group v-model="form.is_open">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <div class="lh18 mt10 gray9">
          <p>注：如开启则移动端显示充值按钮，如果小程序没有资质审核不过可不开启</p>
        </div>
      </el-form-item>
      <el-form-item label="是否开启自定义金额">
        <el-radio-group v-model="form.is_plan">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <div class="lh18 mt10 gray9">
          <p>注：如开启则用户可以填写充值金额</p>
        </div>
      </el-form-item>
      <el-form-item label="最低充值金额" prop="min_money" :rules="[{required: true,message: ' '}]">
        <el-input placeholder="请输入内容" v-model="form.min_money" class="max-w460">
          <template slot="append">元</template>
        </el-input>
        <div class="lh18 mt10 gray9">
          <p> 注：自定义充值金额最低充值多少元</p>
        </div>
      </el-form-item>
      <el-form-item label="充值说明" :rules="[{required: true,message: ' '}]">
        <el-input type="textarea" rows="5" v-model="form.describe" autocomplete="off"></el-input>
      </el-form-item>

      <!--会员充值返佣-->
    <div class="common-form mt50">会员充值返佣</div>
    <el-form-item label="是否开启会员充值返佣：">
      <el-radio-group v-model="form.open_commission">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
       <div class="lh18 mt10 red">
          <p> 注：开启后，后台充值将根据用户关系 进行充值返利</p>
        </div>
    </el-form-item>
    <el-form-item label="" v-if="form.open_commission==1">
      <div class="max-w460">
        <el-table :data="gradeList" border size="mini" style="width: 100%">
          <el-table-column prop="name" label="会员等级">
          </el-table-column>
          <el-table-column prop="name" label="一级奖励">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.first_money" type="number" min="0" max=100 placeholder="奖励比例"></el-input>
                <span class="ml10">%</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="二级奖励">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.second_money" type="number" min="0" max="100" placeholder="奖励比例"></el-input>
                <span class="ml10">%</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" size="small" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
  import BalanceApi from '@/api/balance.js';
  export default {
    data() {
      return {
        form: {

        },
        gradeList:[],
        loading: false,
      };
    },
    created() {
      /*获取数据*/
      this.getData();
    },
    methods: {
      /*获取数据*/
      getData() {
        let self = this;
        let Params = {};
        BalanceApi.getSettings(Params, true).then(res => {
          if(res.data.values.commission!=null&&typeof res.data.values.commission !='undefined'){
            let commission=res.data.values.commission;
            res.data.gradeList.forEach(item=>{
              item.first_money=commission[item.grade_id].first_money;
              item.second_money=commission[item.grade_id].second_money;
            });
          }
          self.form = res.data.values;
          self.gradeList = res.data.gradeList;
          
        }).catch(error => {

        });
      },
    /*转JSON字符串*/
    convertJson(list){
      let obj={};
      list.forEach(item=>{
        let temp = {}
        temp.first_money = item.first_money;
        temp.second_money = item.second_money;
        obj[item.grade_id]=temp;

      });
      return obj;
      return JSON.stringify(obj);
    },
      /*保存*/
      onSubmit() {
        let self = this;
        let form = self.form;
        // console.log(form,self.gradeList);return;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            form.commission=self.convertJson(self.gradeList);
            // console.log(form);return;
            BalanceApi.setSettings(form, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，保存成功',
                    type: 'success'
                  });
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/user/balance/part/Setting.vue